export function numberFormat(
    value,
    digits = 2,
    style = 'decimal', // decimal, currency, percent, unit
    replace = false
) {
    value = style === 'percent' ? value / 100 : value
    const number = new Intl.NumberFormat('en-IN', {
        style: style,
        currency: 'INR',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
        // roundingMode: 'floor',
    }).format(value)
    if (replace) return number.replaceAll(',', '')
    return number
}

export function userName(user) {
    if (!user) return
    return (
        <div className="flex items-center gap-3">
            <div className="relative w-full h-11 max-w-11">
                <img src={user.image_url + '?h=44&w=44&aspect=true&type=webp'} alt={user.name} />
            </div>
            <div className="w-full truncate">
                <p className="text-black dark:text-white">{user.name}</p>
                <p className="text-xs font-medium">{user.email}</p>
                <p className="text-xs font-medium">{user.mobile_no}</p>
            </div>
        </div>
    )
}

export function userVerified(verified, check = false) {
    var className = ''
    var name = ''
    switch (verified) {
        case null:
            className = 'text-danger bg-danger'
            name = 'Not Verified'
            break
        default:
            className = 'text-success bg-success'
            name = 'Verified'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Active'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Inactive',
                },
                {
                    id: 1,
                    label: 'Active',
                },
            ]
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userType(guard, check = false) {
    var className = ''
    var name = ''
    switch (guard) {
        case 'admin':
            className = 'text-danger bg-danger'
            name = 'Admin'
            break
        case 'customer':
            className = 'text-danger bg-danger'
            name = 'Customer'
            break
        case 'service_staff':
            className = 'text-danger bg-danger'
            name = 'Service Staff'
            break
        case 'store':
            className = 'text-danger bg-danger'
            name = 'Store'
            break
        default:
            className = 'text-success bg-success'
            name = 'User'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function yesNo(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'No'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Yes'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'No',
                },
                {
                    id: 1,
                    label: 'Yes',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userRole(guard, check = false) {
    var className = ''
    var name = ''
    switch (guard) {
        case 'admin':
            className = 'text-danger bg-danger'
            name = 'Admin'
            break
        case 'user':
            className = 'text-success bg-success'
            name = 'User'
            break
        case 'customer':
            className = 'text-info bg-info'
            name = 'Customer'
            break
        case 'service_staff':
            className = 'text-secondary bg-secondary'
            name = 'Service Staff'
            break
        case 'store':
            className = 'text-warning bg-warning'
            name = 'Store'
            break
        default:
            className = 'text-info bg-info'
            name = 'Employee'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function orderRequestsStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Approve'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function orderStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Complete'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function warrantyServiceStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 0:
            className = 'text-warning bg-warning'
            name = 'Pending'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'In Progress'
            break
        case 2:
            className = 'text-success bg-success'
            name = 'Complete'
            break
        case 3:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Pending',
                },
                {
                    id: 1,
                    label: 'In Progress',
                },
                {
                    id: 2,
                    label: 'Complete',
                },
                {
                    id: 3,
                    label: 'Reject',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function customerRequestsStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-info bg-info'
            name = 'In Progress'
            break
        case 2:
            className = 'text-success bg-success'
            name = 'Complete'
            break
        case 3:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        default:
            className = 'text-warning bg-warning'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function walletStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-danger bg-danger'
            name = 'Debit'
            break
        default:
            className = 'text-success bg-success'
            name = 'Credit'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function progressStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Finish Goods'
            break
        case 2:
            className = 'text-warning bg-warning'
            name = 'All Machine in Progress'
            break
        case 3:
            className = 'text-danger bg-danger'
            name = 'Insufficient Payment'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Work in Progress'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function withdrawalRequestsStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Pay'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Reject'
            break
        default:
            className = 'text-warning bg-warning'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function serviceInspectionType(type, check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 'text':
            className = 'text-info bg-info'
            name = 'Text'
            break
        case 'textarea':
            className = 'text-info bg-info'
            name = 'Textarea'
            break
        case 'number':
            className = 'text-info bg-info'
            name = 'Number'
            break
        case 'radiobutton':
            className = 'text-success bg-success'
            name = 'Radio Button'
            break
        case 'checkbox':
            className = 'text-success bg-success'
            name = 'Checkbox'
            break
        case 'date':
            className = 'text-warning bg-warning'
            name = 'Date'
            break
        case 'time':
            className = 'text-warning bg-warning'
            name = 'Time'
            break
        case 'file':
            className = 'text-danger bg-danger'
            name = 'File'
            break
        case 'select':
            className = 'text-secondary bg-secondary'
            name = 'Select'
            break
        default:
            name = [
                { id: 'text', label: 'Text' },
                { id: 'textarea', label: 'Textarea' },
                { id: 'number', label: 'Number' },
                { id: 'radiobutton', label: 'Radio Button' },
                { id: 'checkbox', label: 'Checkbox' },
                { id: 'date', label: 'Date' },
                { id: 'time', label: 'Time' },
                { id: 'file', label: 'File' },
                { id: 'select', label: 'Select' },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function warrantyServicesStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Submitted'
            break
        default:
            className = 'text-warning bg-warning'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function machineName(data) {
    return (
        <div className="flex items-center gap-3">
            <div className="relative w-full h-11 max-w-11">
                <img src={data.image_url + '?h=44&w=44&aspect=true&type=webp'} alt={data.name} />
            </div>
            <div className="w-full truncate">
                <p className="text-black dark:text-white">{data.name}</p>
            </div>
        </div>
    )
}

export function machineList(data) {
    return (
        <div className="flex flex-col gap-1">
            {data.map((machine, index) => (
                <p key={index}>
                    {machine.machine.name} ({machine.machine.machine_type.name}) x {machine.qty}
                </p>
            ))}
        </div>
    )
}
